// Light Device Type Templates

import { Template01_Full } from './Template01_Full';

export { Template01_Full } from './Template01_Full';

// Template registry for dynamic selection
export const LightTemplates = {
  Template01: () => import('./Template01_Full').then(m => m.Template01_Full),
} as const;

// Default export
export default Template01_Full;
